import { MRT_RowData } from "material-react-table";
import { useMemo } from "react";

import { MRT_OrderedColumnDef } from "@/types/common-types";

export const useOrderedColumns = <T extends MRT_RowData>(columns: MRT_OrderedColumnDef<T>[]) =>
  useMemo(() => columns.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)), [columns]);
